var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21274 7.96026V6.19725C3.26473 3.96729 4.56948 1.92718 6.64814 0.825795C8.72674 -0.275265 11.2729 -0.275265 13.3515 0.825795C15.4301 1.92707 16.7352 3.96718 16.7871 6.19725V7.96026C17.6392 7.96026 18.4563 8.27604 19.059 8.83838C19.6614 9.40053 20 10.1632 20 10.9584V21.0021V21.0019C20 21.7972 19.6614 22.5597 19.059 23.1219C18.4563 23.6842 17.6392 24 16.7871 24H3.21285C2.36076 24 1.54343 23.6842 0.941021 23.1219C0.338383 22.5597 0 21.7972 0 21.0019V10.9582C0 10.163 0.338406 9.40032 0.941021 8.83817C1.54343 8.27581 2.36076 7.96005 3.21285 7.96005L3.21274 7.96026ZM8.71647 17.6651C8.71647 18.0936 8.96142 18.4894 9.35898 18.7038C9.75655 18.918 10.2465 18.918 10.644 18.7038C11.0416 18.4895 11.2865 18.0936 11.2865 17.6651V14.2922C11.2865 13.8639 11.0416 13.468 10.644 13.2537C10.2464 13.0395 9.75651 13.0395 9.35898 13.2537C8.96141 13.468 8.71647 13.8639 8.71647 14.2922V17.6651ZM5.78308 7.96026L14.2168 7.96046V6.19746C14.176 4.81741 13.3634 3.5582 12.0754 2.87897C10.7875 2.19989 9.21245 2.19989 7.92444 2.87897C6.63649 3.55826 5.82387 4.81741 5.78308 6.19746V7.96026Z",
    fill: "#55608E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ef5148cee51e9a51ab50a0d5ab399251.svg";
export { ForwardRef as ReactComponent };